import common from "../common";
import Scene from "./Scene";
import Button from "../ui/Button";
import Text from "../ui/Text";

export default class GameCompleteScene extends Scene {
    constructor()
    {
        super('GameCompleteScene');

        this.spines = null;
    }

    init()
    {
        super.init('bg');

        this.spines = [];

        var characters = [
            common.config.characters[common.character]
        ];

        for(var i in common.config.settings.gameFlow.enemyOrder)
        {
            characters.push( common.config.characters[common.config.settings.gameFlow.enemyOrder[i]] );
        }

        console.log(characters);

        var characterDisplay = [
            {scaleX:0.9, scaleY:0.9, x:common.STAGE_HALF_WIDTH-240, y:common.STAGE_HEIGHT+30, animations:'_idle_victory'},
            {scaleX:-0.5, scaleY:0.5, x:common.STAGE_HALF_WIDTH+90, y:common.STAGE_HALF_HEIGHT + 100, animation:'char_idle_sit'},
            {scaleX:-0.5, scaleY:0.5, x:common.STAGE_HALF_WIDTH+250, y:common.STAGE_HALF_HEIGHT + 130, animations:'_idle_lose'},
            {scaleX:-0.55, scaleY:0.55, x:common.STAGE_HALF_WIDTH+380, y:common.STAGE_HALF_HEIGHT + 170, animations:'_idle_lose'},
        ];

        for(var i in characterDisplay)
        {
            var spineData = P3.assets.spineData(characters[i].spine + '_big');

            common.display.sprite({asset:'food_shadow', x:characterDisplay[i].x, y:characterDisplay[i].y, anchorX:0.4, anchorY:0.4, scaleX:3, scaleY:0.5, parent:this});

            let spine = new PIXI.spine.Spine(spineData);
            spine.scale.set(characterDisplay[i].scaleX, characterDisplay[i].scaleY);
            spine.x = characterDisplay[i].x;
            spine.y = characterDisplay[i].y;
            spine.skeleton.setSlotsToSetupPose();
            spine.skeleton.setToSetupPose();
            spine.autoUpdate = false;

            if(characterDisplay[i].animations)
            {
                spine.state.setAnimation(0, 'body' + characterDisplay[i].animations, true);
                spine.state.setAnimation(1, 'legs' + characterDisplay[i].animations, true);
            }
            else if(characterDisplay[i].animation)
            {
                spine.state.setAnimation(0, characterDisplay[i].animation, true);
            }

            if(characters[i].skin)
            {
                spine.skeleton.setSkin(spine.spineData.findSkin(characters[i].skin));
            }

            this.spines.push(spine);
            this.addChild(spine);
        }

        this.buttons.play = new Button(new P3.ButtonStates(
            P3.assets.texture('btn_primary_large_out'),
            P3.assets.texture('btn_primary_large_over'),
            P3.assets.texture('btn_primary_large_down'),
            P3.assets.texture('icon_play')
        ));
        this.buttons.play.id = 'play';
        this.buttons.play.icon.anchor.set(0.45, 0.53);
        this.buttons.play.x = common.STAGE_HALF_WIDTH;
        this.buttons.play.y = common.STAGE_HEIGHT - 200;
        this.signalListeners.push(this.buttons.play.signals.click.add(this.onButtonClicked, this));
        this.addChild(this.buttons.play);

        var titleText = new Text(common.text.translate('congratulations'), {
            font: 60 + "px Lalezar56",
            align: "center"/*,
            tint: 0x000000*/
        });
        titleText.x = common.STAGE_HALF_WIDTH;
        titleText.y = common.STAGE_HALF_HEIGHT - 300;
        titleText.anchor.set(0.5);
        this.addChild(titleText);
    }

    destroy()
    {
        common.audio.stopSound('music_results_loop');
        super.destroy();
    }

    update()
    {
        super.update();

        for(var i in this.spines)
        {
            this.spines[i].update(P3.Ticker.dt * common.timeStretch);
        }
    }

    resize()
    {
        super.resize();
    }

    onButtonClicked(button)
    {
        if(button.id == 'play')
        {
            this.signals.next.dispatch();
        }
    }
}